import { Coffee, Gamepad2 } from "lucide-react";

const Footer = () => {
	return (
		<footer className="border-t border-border bg-card py-10">
			<div className="max-w-screen-2xl mx-auto px-3 grid grid-cols-1 sm:grid-cols-3 gap-8">
				<div>
					<a href="/" target="_blank" className="flex items-center gap-2 mb-3">
						<Coffee className="h-6 w-6 text-primary" />
						{/* <img
							src="/android-chrome-512x512.png"
							alt="Logo"
							className="h-8 sm:h-10 md:h-11 rounded-md transition-transform group-hover:scale-105"
						/> */}
						<span className="text-lg space-x-1 font-display font-bold text-foreground">
							<span> Coffee Game</span><span className="text-primary">Online</span>
						</span>
					</a>
					<p className="text-sm text-muted-foreground">
						Discover and play free browser games instantly.
					</p>
				</div>

				<div>
					<h4 className="font-semibold text-foreground mb-3 text-sm">Platform</h4>
					<ul className="space-y-2 text-sm text-muted-foreground">
						<li><a href="/?sort=trending" target="_blank" className="hover:text-primary transition-colors">Trending</a></li>
						<li><a href="/?sort=new" target="_blank" className="hover:text-primary transition-colors">New Games</a></li>
						<li><a href="/?showFilters=1" target="_blank" className="hover:text-primary transition-colors">Categories</a></li>
						<li><a href="/upload" target="_blank" className="hover:text-primary transition-colors">Upload a Game</a></li>
					</ul>
				</div>

				<div>
					<h4 className="font-semibold text-foreground mb-3 text-sm">Company</h4>
					<ul className="space-y-2 text-sm text-muted-foreground">
						<li><a href="/contact" target="_blank" className="hover:text-primary transition-colors">Contact Us</a></li>
						<li><a href="/privacy" target="_blank" className="hover:text-primary transition-colors">Privacy Policy</a></li>
						<li><a href="/about" target="_blank" className="hover:text-primary transition-colors">About Us</a></li>
					</ul>
				</div>
			</div>

			<div className="max-w-6xl mx-auto px-6 mt-8 pt-6 border-t border-border text-center text-xs text-muted-foreground">
				© {new Date().getFullYear()} Coffee Game Online. All rights reserved.
			</div>
		</footer>
	);
};

export default Footer;
